<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="caption keep-spaces">
      <v-row no-gutters>
        <v-col cols="3">
          <v-icon small color="blue">mdi-sitemap</v-icon>
          {{rule.name}}</v-col>
        <v-col cols="9">
          <v-chip-group column>
            <div v-for="chip in chips" :key="chip.key">
              <v-tooltip bottom color="secondary">
                <template v-slot:activator="{ on }">
                  <v-chip :color="chip.color" v-on="on" small>
                    <v-avatar left>
                      <v-icon small>{{chip.icon}}</v-icon>
                    </v-avatar>
                    {{chip.script}} {{chip.special}}
                  </v-chip>
                </template>
                <span class="caption font-weight-bold">
                  <span>{{chip.type}}</span> 
                  <span class="grey--text">[{{chip.ext}}]</span>
                </span>
                <Code v-if="chip.settings" v-bind:code="chip.settings" />
              </v-tooltip>
            </div>
          </v-chip-group>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <Code v-bind:code="rule" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Code from "../Code";

export default {
  name: "RulesMain",
  props: ["rule"],
  components: { Code },
  beforeMount() {
    let events = this.$props.rule.events;
    let actions = this.$props.rule.actions;
    let conditions = this.$props.rule.conditions;
    let chipData = [];

    events.forEach((ev, i) => {
      let path = ev.modulePath;
      let split = path.split("/");
      let ext = split[0];
      let script = split[split.length - 1].replace(".js", "");
      let settings = ev.settings;
      let special = `[${ev.ruleOrder}]`;
      chipData.push({
        ext, // core
        script, // valueComparison
        settings, // => code for hover?
        special, // [5]
        icon: "mdi-gesture-tap",
        type: "Event",
        key: `event-${i}`,
        color: "blue"
      });
    });

    conditions.forEach((con, i) => {
      let path = con.modulePath;
      let split = path.split("/");
      let ext = split[0];
      let script = split[split.length - 1].replace(".js", "");
      let settings = con.settings;
      let type = !con.negate ? "Condition" : "Exception";
      let special = "";
      chipData.push({
        ext, // core
        script, // valueComparison
        settings, // => code for hover
        special, // [5]
        icon: "mdi-call-split",
        type,
        key: `condition-${i}`,
        color: con.negate ? "red" : "green"
      });
    });

    actions.forEach((act, i) => {
      let path = act.modulePath;
      let split = path.split("/");
      let ext = split[0];
      let script = split[split.length - 1].replace(".js", "");
      let settings = act.settings;

      /*
      if (ext === "core" && !settings.isExternal && settings.language === "javascript") {
        settings.source = new Function(settings.source).toString().replace(/\\n/g,''); / doesnt work....
        //console.log(typeof settings.source)
      }
      */

      let special = "";
      chipData.push({
        ext, // core
        script, // valueComparison
        settings, // => code for hover?
        special, // [5]
        icon: "mdi-crosshairs",
        type: "Action",
        key: `action-${i}`,
        color: "orange"
      });
    });

    this.chips = chipData;
  },
  data() {
    return {
      chips: []
    };
  }
};
</script>